import React, { useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "./UnifiedFormStyles.css";
import AppButton from "../../Components/MerchantButton";

function TroubleShootP1Sticker({ navigation, primaryDetails, setPrimaryDetails }) {
  const [isError, setIsError] = useState({
    p1_sticker_distribution: false,
  });

  // Yes/No options
  const YES_NO_OPTIONS = ["Yes", "No"];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPrimaryDetails(prev => ({ ...prev,
      [name]: value,
    }));

    // Clear error when user makes a selection
    if (isError[name]) {
      setIsError({
        ...isError,
        [name]: false,
      });
    }
  };

  const validateForm = () => {
    const errors = {
      p1_sticker_distribution: !primaryDetails.p1_sticker_distribution,
    };

    setIsError(errors);

    const hasErrors = Object.values(errors).some(error => error);
    if (hasErrors) {
      toast.error("Please select Yes or No", {
        autoClose: 3000,
        hideProgressBar: true,
        theme: "colored",
      });
      return false;
    }
    return true;
  };

  const handleNext = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (validateForm()) {
      if (primaryDetails.p1_sticker_distribution === "Yes") {
        navigation.go("troubleshoot-p1-sticker-photo");
      } else {
        navigation.go("remarks");
      }
    }
  };

  const handleBack = (e) => {
    navigation.previous();
  };

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">

          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">Troubleshoot P1 Sticker</h4>
              <p className="form-desc">Please indicate if this merchant has a P1 Sticker</p>
            </div>
            <div className="form-main">
              <div className="form-main-content">
                <Form>
                  {/* Yes/No Question */}
                  <Form.Group className="mb-5" controlId="p1_sticker_distribution">
                    <Form.Label className="form-label">
                      Nagbigay o nagdikit ka ba ng Troubleshoot P1 Sticker? <span className="form-required">*</span>
                    </Form.Label>
                    <div className="form-radio-group">
                      {YES_NO_OPTIONS.map((option, index) => (
                        <div
                          key={`troubleshoot-p1-${index}-${option}`}
                          className={`form-radio-item${primaryDetails.p1_sticker_distribution === option ? " selected" : ""}`}
                        >
                          <div className="form-radio-flex">
                            <Form.Check
                              type="radio"
                              name="p1_sticker_distribution"
                              value={option}
                              label={option}
                              onChange={handleInputChange}
                              checked={primaryDetails.p1_sticker_distribution === option}
                              className="form-radio"
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                    {isError.p1_sticker_distribution && (
                      <div className="form-error">
                        Please select Yes or No
                      </div>
                    )}
                  </Form.Group>

                  {/* Navigation Buttons */}
                  <div className="form-btn-row">
                    <AppButton
                      type="button"
                      onClick={handleBack}
                      variant="back"
                      className="form-btn variant-secondary"
                    >
                      ← Back
                    </AppButton>
                    <AppButton
                      type="button"
                      onClick={handleNext}
                      variant="next"
                      className="form-btn variant-primary"
                    >
                      Next →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>

        </Row>
      </Container>
    </div>
  );
}

export default TroubleShootP1Sticker;
